import $ST from "plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail";
import React, { Component } from "react";
import PackageItemRow from "../packageItemRow";
import { Checkbox, Button } from "antd";
import Modal from "components/ui-ant/Feedback/modal";
import PrintableArea from "components/partials/PrintableArea";
import PrintableView from "../../../printableView";
import $S from "theme/settings";
import $APP from "plugins/tfs/platformConfigs/app";
import "../../../main/style.css";

class BarcodeModal extends Component {
  nextInputTimeout = null;
  state = {
    isFormValid: true,
    currentBarcodeIndex: 0,
    barcodes: [],
    validations: [],
    focusOnInputNumber: false,
    MNS: $APP.TITLE === "M & S Instore" || "Sportive Instore",
    isPackClicked: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.barcodes !== this.props.barcodes) {
      const validations = this.getValidations();
      const isFormValid = validations.every(Boolean);
      this.setState({ validations, isFormValid });
    }
  }

  getValidations = () => {
    const { packageItemSet, barcodes } = this.props;

    const hasAnyBarcode = packageItemSet.some(({ id }) => !!barcodes[id]);

    return packageItemSet.map(({ id, orderItem }) => {
      const expectedBarcode = orderItem.product.attributes.integration_edi;
      const enteredBarcode = barcodes[id];

      if (!hasAnyBarcode) {
        return true;
      }

      return expectedBarcode === enteredBarcode;
    });
  };

  onChangeHandler = (isValid, barcode, index) => {
    const { validations } = this.state;
    const { is } = Object;
    const isDefined = !is(validations[index], undefined);

    if (isDefined) {
      validations[index] = isValid;
      isValid && index++;
    }

    const isFormValid = validations.every(Boolean);

    this.setState({
      isFormValid,
      currentBarcodeIndex: index,
    });
  };

  onChangeHandlerWithBarcode = (isValid, barcode, index) => {
    this.nextFocusTimeout && clearTimeout(this.nextFocusTimeout);

    const { packageItemSet } = this.props;

    if (!packageItemSet[index]) {
      return;
    }

    const { orderItem: { id: order_item } = {} } = packageItemSet[index];
    const { barcodes = [] } = this.state;
    const prevItemIndex = barcodes.findIndex(
      (item) => item.order_item === order_item,
    );

    if (prevItemIndex > -1) {
      barcodes.splice(prevItemIndex, 1);
    }

    const item = { order_item, barcode, isValid };
    const newBarcodes = [...barcodes, item];

    const hasAnyBarcode = newBarcodes.some(({ barcode }) => !!barcode);

    const isFormValid =
      !hasAnyBarcode ||
      (newBarcodes.length === packageItemSet.length &&
        newBarcodes.every(({ isValid }) => isValid));

    this.nextFocusTimeout = setTimeout(() => {
      this.setState({
        isFormValid,
        barcodes: newBarcodes,
        currentBarcodeIndex: isValid ? barcode && ++index : index,
      });
    }, 300);
  };

  get printButton() {
    const { packageOrder } = this.props;
    const isVisible = $S.isPackageOrderDetailPrintable;
    const printableArea = (
      <PrintableArea
        key="print"
        trigger={
          <Button className="print-button print-button-adapter">
            {$ST.PRINT}
          </Button>
        }
      >
        <PrintableView {...{ packageOrder }} />
      </PrintableArea>
    );

    return isVisible && packageOrder ? [printableArea] : [];
  }

  get isValidationActive() {
    return $S.isPackageOrderDetailBarcodeValidationActive;
  }

  clickPackageButton = (actionData, barcodes) => {
    const { onActionFire } = this.props;

    onActionFire(actionData, barcodes);

    this.setState({
      isPackClicked: true,
    });
  };

  render() {
    const { visible, packageOrder, packageItemSet, onClose, actionData } =
      this.props;
    const {
      barcodes,
      currentBarcodeIndex = 0,
      focusOnInputNumber,
      isPackClicked,
      isFormValid,
    } = this.state;

    return (
      <Modal
        className="package-modal oms"
        visible={visible}
        onCancel={onClose}
        title={$ST.SCAN_BARCODE}
        centered
        footer={[
          ...this.printButton,
          <Button key="back" onClick={onClose}>
            {$ST.CANCEL}
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!isFormValid || isPackClicked}
            onClick={() => this.clickPackageButton(actionData, barcodes)}
          >
            {isPackClicked ? $ST.PACKING : $ST.PACK}
          </Button>,
        ]}
      >
        <Checkbox.Group>
          {packageItemSet &&
            packageItemSet.map((packageItem, index) => {
              return (
                <PackageItemRow
                  packageItem={packageItem}
                  key={packageItem.id}
                  rowId={index}
                  initialValue={this.props.barcodes[packageItem.id]}
                  setBarcode={(id, value) => {
                    if (focusOnInputNumber) {
                      this.setState({ focusOnInputNumber: false });
                    }
                    this.props.setBarcode(id, value);
                  }}
                  setWeight={(id, value) => {
                    if (!focusOnInputNumber) {
                      this.setState({ focusOnInputNumber: true });
                    }
                    this.props.setWeight(id, value);
                  }}
                  focus={index === currentBarcodeIndex}
                  stateEnumValue={packageOrder.state.enum_value}
                  focusOnInputNumber={focusOnInputNumber}
                  onBarcodeChange={
                    this.isValidationActive
                      ? this.onChangeHandler
                      : this.onChangeHandlerWithBarcode
                  }
                  isUIValidationActive={this.isValidationActive}
                />
              );
            })}
        </Checkbox.Group>
      </Modal>
    );
  }
}

export default BarcodeModal;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/modals/barcode/main/index.js